import React from "react";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import * as settings from "../shared/settingsConstants"

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(10),
    },
    containerLogo: {
        padding: 50,
        backgroundColor: theme.palette.custom ? theme.palette.custom.logoBackgroundColour : settings.portalSettings.logoBackgroundColour
    },
    containerMain: {
        paddingTop: 20,
        paddingBottom: 50
    },
    logo: {
        height: 50,
        marginRight: "auto",
        marginLeft: "auto",
        display: "block",
    },
}));

function AuthOutlet(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [useDefaultLogo, setUseDefaultLogo] = React.useState({wait: false, useDefault: false});

    const childrenWithProps = React.Children.map(props.rootOutlet, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { setUseDefaultLogo });
        }
        return child;
    });

    return (
        <main>
            <CssBaseline />
            <div className={classes.paper}>
                <Container maxWidth="lg">
                    <Paper elevation={5}>
                        <Container maxWidth="lg" className={classes.containerLogo}>
                            <img style={{ visibility: useDefaultLogo.wait ? 'hidden' : 'visible' }} src={theme.palette.custom && !useDefaultLogo.useDefault ? theme.palette.custom.logoSrc : settings.portalSettings.logoSrc} className={classes.logo} alt="logo" />
                        </Container>
                        <Container maxWidth="lg" className={classes.containerMain}>
                            {childrenWithProps}
                            <div className="copyright">
                                &copy; <a href="https://www.inscope-aml.com" className="copyright-link">InScope-AML</a> - Self-Service Portal
                            </div>
                        </Container>
                    </Paper>
                </Container>
            </div>
        </main>
    );
}

export default AuthOutlet;
